/**
 * The simulated push notification (#106) — module-scope state half.
 *
 * Ported from app-salon-tools' pseudo-notification (alerts store type
 * 'pseudo-notification' + PseudoNotificaction.vue, commit 205b6630): an
 * in-app banner styled like a native OS push, used where a real push cannot
 * exist — the vitrina has no service worker and no permission, on purpose
 * (Planning §2.3, parked by René).
 *
 * FIFO queue, one visible at a time (the original queued too): two status
 * changes landing in one poll each get their banner instead of the second
 * silently replacing the first (Codex). Display timing lives in the
 * COMPONENT — expiry must run the same leave animation a tap runs, so the
 * composable never dismisses on a timer of its own.
 */

import { computed, ref } from 'vue';

const queue = ref([]);

const active = computed(() => queue.value[0] || null);

/** Enqueue one notification: `{ title, body, onClickAction? }`. */
function show(notification) {
  if (!notification || (!notification.title && !notification.body)) return;
  queue.value = [...queue.value, notification];
}

/** Retire the visible notification; the next in line (if any) shows. */
function dismiss() {
  queue.value = queue.value.slice(1);
}

/** Test hook. */
function resetForTests() {
  queue.value = [];
}

export function usePseudoNotification() {
  return { active, show, dismiss, resetForTests };
}
